import React from "react";
import type { UserBackgroundOperationSummary } from "src/api/generated/backgroundOperations/user/userBackgroundOperationSummary.ts";
import type { AsyncState } from "src/utils/async/asyncState.ts";
import { useContextOrThrow } from "src/utils/useContextOrThrow.tsx";

export interface BackgroundOperationsContextValue {
	activeOperationsAsync: AsyncState<UserBackgroundOperationSummary[]>;
	refreshActiveOperations: (silent?: boolean) => Promise<UserBackgroundOperationSummary[]>;
}

export const BackgroundOperationsContext = React.createContext<BackgroundOperationsContextValue | undefined>(
	undefined,
);

export function useBackgroundOperations() {
	return useContextOrThrow(BackgroundOperationsContext);
}
